import React, { useCallback, useMemo, useState, useRef, useEffect } from 'react'

import Charts from 'react-apexcharts';
import PropTypes from 'prop-types';

import { isEmpty, round } from 'lodash';
import { format, parseISO } from 'date-fns';
import { parseDateString } from '~/helpers';

export default function GraphicAbastecimento({
    data,
    sending,
    visible,
    toggleDisabled,
}) {

    const [volumes, setVolumes] = useState([])
    const [dates, setDates] = useState([])
    const [categories, setCategories] = useState([])


    useEffect(() => {
        if (!isEmpty(data)) {
            handleGetDataGraphic(data)
        }

    }, [data])

    const handleGetDataGraphic = useCallback((data) => {
        let arrayVolumes = [];
        let arrayDatas = [];
        data.forEach(item => {
            arrayVolumes.push(item.volume)
            arrayDatas.push(format(new Date(item.date), 'dd/MM/yyyy'))
        });

        setVolumes(arrayVolumes)
        setDates(arrayDatas)

    }, [])

    const graphicState = useMemo(() => ({
        options: {
            chart: {
                id: "basic-bar",
                toolbar: {
                    show: true,
                    tools: {
                        download: true,
                        selection: false,
                        zoom: false,
                        zoomin: false,
                        zoomout: false,
                        pan: false,
                    },
                }
            },
            dataLabels: {
                enabled: false,

            },
            stroke: {
                curve: 'smooth',
                colors: ['transparent'],
                width: 5,
                curve: ['smooth', 'straight', 'stepline']
            },
            xaxis: {
                tickPlacement: 'on',
                categories: dates,
                overwriteCategories: categories,


            }
        },

        series: [
            {
                name: "Volume",
                data: volumes
            }
        ]


    }), [volumes, dates, categories]

    )

    useEffect(() => {

        let tempCategories = dates.filter((value) => {
            let inicio = dates[0]
            let fim = dates[dates.length - 1]
            let meio = dates[round(dates.length / 2)]
            if (value == inicio || value == meio || value == fim) {
                return true
            }
            return false
        })

        setCategories(tempCategories)

    }, [volumes, dates])

    return (
        <>
            {
                volumes.length > 0 && dates.length > 0 && <Charts
                    options={graphicState.options}
                    series={graphicState.series}
                    type="bar"
                    width="100%"
                    height="300px"
                />

            }

        </>
    )

}

GraphicAbastecimento.propTypes = {
    data: PropTypes.arrayOf(PropTypes.any),
}

GraphicAbastecimento.defaultProps = {
    data: []

}


